import render from './render'

export default {
  name: 'Copyright',

  computed: {
    value() {
      const result = [ '©' ]
      result.push(this.globalSettings?.frontend?.title)
      result.push(new Date().getFullYear())

      return result.filter(Boolean).join(' ')
    }
  },

  render
}
